import {
  addHtmlElementClass,
  addHtmlElementEventListener,
  getHtmlElement,
  obj2string,
  parseHoursRange,
  removeHtmlElementClass,
  renderWebComponent
} from "../../../utils/utils";
import I18n from 'i18n.js.erb';
import commonStyles from '../../styles/web-components.common.css';
import submissionListsStyles from '../../styles/submission-lists.css';
import { EventBusComponent } from "../EventBusComponent";


export class SubmissionListConfirmationComponent extends HTMLElement {
  props = {};

  constructor(props) {
    super();
    this.attachShadow({ mode: 'open'});
    this.props = props;
    this.eventBus = EventBusComponent.getInstance();
    this.render();
  }

  connectedCallback() {
    addHtmlElementEventListener(this.shadowRoot, 'user_area_link', 'mouseout', () => this.handleEnablingDefaultLink(true))
    addHtmlElementEventListener(this.shadowRoot, 'submission_lists_link', 'mouseout', () => this.handleEnablingDefaultLink(true))
    addHtmlElementEventListener(this.shadowRoot, 'user_area_link', 'mouseover', () => this.handleEnablingDefaultLink(false))
    addHtmlElementEventListener(this.shadowRoot, 'submission_lists_link', 'mouseover', () => this.handleEnablingDefaultLink(false))
    window.addEventListener('resize', () => this.resizeInfoCol())
  }


  // Funzione che si occupa di evidenziare sull'interfaccia grafica il link di default tra quelli che si trovano
  // in fondo alla pagina in base al modo con cui l'utente muove il mouse sopra di essi
  handleEnablingDefaultLink (enable) {
    if (enable) {
      addHtmlElementClass(this.shadowRoot, 'start_submission', 'btn')
      addHtmlElementClass(this.shadowRoot, 'start_submission', 'bg-aig-gradient')
      addHtmlElementClass(this.shadowRoot, 'start_submission', 'color-white')
      addHtmlElementClass(this.shadowRoot, 'start_submission', 'border-none-imp')
      addHtmlElementClass(this.shadowRoot, 'start_submission', 'br-50px')
      addHtmlElementClass(this.shadowRoot, 'start_submission', 'py-06rem-px-3rem')
      removeHtmlElementClass(this.shadowRoot, 'start_submission', 'btn-aig-gradient-outline')
    } else {
      removeHtmlElementClass(this.shadowRoot, "start_submission", "btn");
      removeHtmlElementClass(this.shadowRoot, "start_submission", "bg-aig-gradient");
      removeHtmlElementClass(this.shadowRoot, "start_submission", "color-white");
      removeHtmlElementClass(this.shadowRoot, "start_submission", "border-none-imp");
      removeHtmlElementClass(this.shadowRoot, "start_submission", "br-50px");
      removeHtmlElementClass(this.shadowRoot, "start_submission", "py-06rem-px-3rem");
      addHtmlElementClass(this.shadowRoot, "start_submission", "btn-aig-gradient-outline");
    }
  }



  // Funzione che gestisce il resize dei box informativi che contengono le informazioni per l'utente su come
  // spedire i suoi prodotti alla casa di gradazione
  resizeInfoCol () {
      const maxHeight = getHtmlElement(this.shadowRoot, 'info-col-2').clientHeight;
      for (const i of [1,3,4,5,6])
          getHtmlElement(this.shadowRoot, `info-col-${i}`).style.height = `${maxHeight}px`;
  }
  
  
  
  // Funzione che verifica se debba essere effettuato il ritiro per l'ordine appena confermato
  homePickUpCollect () {
    return this.props.submissionList.home_pick_up_requested || this.props.submissionList.enable_pick_up_request;
  }




  render() {
    const html = ` 
      <div class="w-100 p-0" id="confirmation-container">  
        <div class="row">
          <div class="col-1 col-xl-2"></div>
          <div class="col-10 col-xl-8 text-center">
            <div class="row pt-3">
              <div class="col-12 col-lg-6 col-xl-7 text-left mx-0">
                <div class="mt-5 line-height-1">
                  <h2 class="text-aig-gradient mb-4">
                    <b>${I18n.t('js.editSubmissionListPage.webComponent.confirmation.text1')}</b>
                  </h2>
                  <p class="font-size-24px mb-0">
                    <b>${I18n.t('js.editSubmissionListPage.webComponent.confirmation.text1_1')}</b>
                  </p>
                  <p class="font-size-24px">
                    <b>${I18n.t('js.editSubmissionListPage.webComponent.confirmation.text1_2')}</b>
                  </p>
                </div>
                
                <div class="row mt-3 mb-3">
                  <div class="col-12 px-2 pt-4 text-left">
                    <div class="p-2px bg-aig-gradient br-8px h-100perc happy-ending-info-col position-relative">
                      <div class="bg-white-imp br-8px p-3 h-100perc">
                        <div class="row m-0 p-0">
                          <div class="col-12 col-sm-6 col-lg-12 col-xl-6 m-0 p-0">
                            <p>
                              <b>${I18n.t('js.editSubmissionListPage.webComponent.confirmation.text4')}</b><br>
                              ${this.props.submissionList.number}
                            </p>
                            
                            <p class="mb-0">
                              <b>${I18n.t('js.editSubmissionListPage.webComponent.confirmation.text4_1')}</b>
                              ${
                                this.props.submissionList.user_owner ?
                                  `<br>
                                  <span>${this.props.submissionList.user_owner}</span>`
                                :
                                  ``
                              }
                              ${
                                this.props.submissionList.owner_email && this.props.submissionList.owner_email !== this.props.submissionList.user_owner ?
                                  `<br>
                                   <span>${this.props.submissionList.owner_email}</span>`
                                :
                                  ``
                              }
                            </p>
                          </div>
                          
                          <div class="col-12 col-sm-6 col-lg-12 col-xl-6 m-0 p-0 d-flex align-items-end justify-content-center">
                            <pdf-generator-component
                              props='${obj2string({
                                type: "button",
                                generatorText: I18n.t('js.editSubmissionListPage.webComponent.confirmation.printSummary').toUpperCase(),
                                cssClassList: "btn bg-aig-gradient br-50px color-white border-none-imp mt-4 py-1 px-3",
                                pdfUrl: `/submission_lists/${this.props.submissionList.id}.pdf`,
                                displayDownloadIcon: true,
                                displaySpinner: true,
                              })}'
                            ></pdf-generator-component>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="col-12 col-lg-6 col-xl-5 d-flex justify-content-center align-items-center">
                <div class="position-relative w-100">
                  <img src="/images/submission-list-happy-ending.svg" alt="happy-ending" class="w-100 max-w-500px">
                </div>
              </div>
              
              ${
                this.props.submissionList.state === 'payment_alert' ?
                  `<div class="col-12 my-5 py-4 bg-aig-gradient-light br-20px">
                    <h5>
                      ${I18n.t('js.editSubmissionListPage.webComponent.confirmation.payment_alert.text1')} 
                    </h5>
                    <h5 class="mb-0">
                      ${I18n.t('js.editSubmissionListPage.webComponent.confirmation.payment_alert.text2')} ${this.props.submissionList.grader_company.meta_name} ${I18n.t('js.editSubmissionListPage.webComponent.confirmation.payment_alert.text3')}
                    </h5>
                  </div>`
                :
                  `<div class="col-12 text-aig-gradient m-0 text-left pt-3 z-index-125 confirmation-instructions-section">
                    <h2 class="mb-0"><b>${I18n.t('js.editSubmissionListPage.webComponent.confirmation.text2')}</b></h2>
                    <h2><b>${I18n.t('js.editSubmissionListPage.webComponent.confirmation.text2_1')}</b></h2>
                  </div>
                  
                  <div class="col-12 col-lg-6 col-xxxl-4 px-2 pt-4 text-left">
                    <div class="p-2px bg-aig-gradient br-8px h-100perc happy-ending-info-col position-relative">
                      <div class="bg-aig-gradient instruction-point text-center p-1">
                        1
                      </div>
                      <div class="bg-white-imp br-8px p-3 h-100perc" id="info-col-1">
                        ${I18n.t('js.editSubmissionListPage.webComponent.confirmation.instructions.text1')}
                      </div>
                    </div>
                  </div>
                  
                  <div class="col-12 col-lg-6 col-xxxl-4 px-2 pt-4 text-left">
                    <div class="p-2px bg-aig-gradient br-8px happy-ending-info-col position-relative">
                      <div class="bg-aig-gradient instruction-point text-center p-1">
                        2
                      </div>
                      <div class="bg-white-imp br-8px p-3 h-100perc" id="info-col-2">
                        ${I18n.t(`js.editSubmissionListPage.webComponent.confirmation.instructions.text2_${!this.homePickUpCollect(this.props.submissionList) ? '1' : '2'}`)}
                     
                        <div class="text-center">
                          <pdf-generator-component
                            props='${obj2string({
                              type: "button",
                              generatorText: I18n.t(`js.editSubmissionListPage.webComponent.confirmation.text7_${!this.homePickUpCollect(this.props.submissionList) ? '1' : '2'}`).toUpperCase(),
                              cssClassList: "btn bg-aig-gradient br-50px color-white border-none-imp mt-4 py-1 px-3",
                              pdfUrl: `/submission_lists/${this.props.submissionList.id}/shipment_instructions.pdf`,
                              displayDownloadIcon: false
                            })}'
                          ></pdf-generator-component>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div class="col-12 col-lg-6 col-xxxl-4 px-2 pt-4 text-left">
                    <div class="p-2px bg-aig-gradient br-8px h-100perc happy-ending-info-col position-relative">
                      <div class="bg-aig-gradient instruction-point text-center p-1">
                        3
                      </div>
                      <div class="bg-white-imp br-8px p-3 h-100perc" id="info-col-3">
                        ${
                        !this.homePickUpCollect(this.props.submissionList) ?
                          `<span>${I18n.t('js.editSubmissionListPage.webComponent.confirmation.instructions.text3_1')}</span>`
                          :
                          `
                            <span>
                              ${I18n.t('js.editSubmissionListPage.webComponent.confirmation.instructions.text3_2').replaceAll('#', ' ').replace(':date', this.props.submissionList.home_pick_up_previous_day)}
                            </span>
                          `
                      }
                      </div>
                    </div>
                  </div>
                  
                  <div class="col-12 col-lg-6 col-xxxl-4 px-2 pt-4 text-left">
                    <div class="p-2px bg-aig-gradient br-8px h-100perc happy-ending-info-col position-relative">
                      <div class="bg-aig-gradient instruction-point text-center p-1">
                        4
                      </div>
                      <div class="bg-white-imp br-8px p-3 h-100perc" id="info-col-4">
                        ${I18n.t('js.editSubmissionListPage.webComponent.confirmation.instructions.text4')}<br/>
                        ${
                          this.homePickUpCollect(this.props.submissionList) && this.props.submissionList.home_pick_up_favorite_day_italian_format ?
                            `${I18n.t('js.editSubmissionListPage.webComponent.confirmation.instructions.text5_2')}
                               ${this.props.submissionList.home_pick_up_favorite_day_italian_format}&nbsp;
                               ${this.props.submissionList.home_pick_up_favorite_hour && this.props.submissionList.home_pick_up_favorite_hour !== 'all_day' ? I18n.t('js.editSubmissionListPage.webComponent.confirmation.instructions.text5_3') + ' ' + parseHoursRange(this.props.submissionList.home_pick_up_favorite_hour) + ' ' : ''}
                               ${I18n.t('js.editSubmissionListPage.webComponent.confirmation.instructions.text5_4')}`
                          :
                            this.homePickUpCollect(this.props.submissionList) ?
                              I18n.t('js.editSubmissionListPage.webComponent.confirmation.instructions.text5')
                            :
                              I18n.t('js.editSubmissionListPage.webComponent.confirmation.instructions.text5_1')
                        } ${this.props.submissionList.grader_company.meta_name}.
                      </div>
                    </div>
                  </div>
                  
                  <div class="col-12 col-lg-6 col-xxxl-4 px-2 pt-4 text-left">
                    <div class="p-2px bg-aig-gradient br-8px h-100perc happy-ending-info-col position-relative">
                      <div class="bg-aig-gradient instruction-point text-center p-1">
                        5
                      </div>
                      <div class="bg-white-imp br-8px p-3 h-100perc" id="info-col-5">
                        ${I18n.t('js.editSubmissionListPage.webComponent.confirmation.instructions.text6')}<br/>
                        ${I18n.t('js.editSubmissionListPage.webComponent.confirmation.instructions.text7')}
                      </div>
                    </div>
                  </div>
                  
                  <div class="col-12 col-lg-6 col-xxxl-4 px-2 pt-4 text-left">
                    <div class="p-2px bg-aig-gradient br-8px h-100perc happy-ending-info-col position-relative">
                      <div class="bg-aig-gradient instruction-point text-center p-1">
                        6
                      </div>
                      <div class="bg-white-imp br-8px p-3 h-100perc" id="info-col-6">
                        ${this.props.submissionList.grader_company.meta_name}
                        ${I18n.t('js.editSubmissionListPage.webComponent.confirmation.instructions.text8')}<br/>
                        ${I18n.t('js.editSubmissionListPage.webComponent.confirmation.instructions.text9')}
                        ${this.props.submissionList.grader_company.meta_name}
                        ${I18n.t('js.editSubmissionListPage.webComponent.confirmation.instructions.text10')}
                      </div>
                    </div>
                  </div>`
                }
            </div>
          </div>
          <div class="col-1 col-xl-2"></div>
        </div>
        
        ${
          this.props.submissionList.state !== 'payment_alert' ?
            `<div class="row d-flex justify-content-center text-center mt-5 pb-2 px-5">
              <p>
                ${I18n.t('js.editSubmissionListPage.webComponent.confirmation.closing')} 
                <a href="mailto:${this.props.submissionList.grader_company.email}">
                  ${this.props.submissionList.grader_company.email}
                </a>
              </b>
            </div>`
          :
            ``
        }
       
        <div class="row d-block d-md-flex justify-content-center align-items-center text-center mb-5">
          <div class="p-0 mx-2 my-4">
            <form method="post" 
              onsubmit="start_submission.disabled = true; setTimeout(() => start_submission.disabled = false, 4000); return true;" 
              action="/submission_lists"
            >
              <button id="start_submission"
                name="start_submission"
                class="btn bg-aig-gradient color-white border-none-imp br-50px py-06rem-px-3rem"
                type="submit"
              >
                ${I18n.t('js.indexSubmissionListsPage.createSubmission').toUpperCase()}
              </button>
            </form> 
          </div>
          
          <div class="p-0 mx-2 my-5">
            <a href=${window.origin + '/users/' + this.props.user_id}
              id="user_area_link"
              class="btn-aig-gradient-outline"
            >
              ${I18n.t('js.common.button.myUserArea').toUpperCase()}
            </a>
          </div>
          
          <div class="p-0 mx-2 my-5">
            <a href=${window.origin + '/submission_lists/'}
              id="submission_lists_link"
              class="btn-aig-gradient-outline"
            >
              ${I18n.t('js.common.submissionLists').toUpperCase()}
            </a>
          </div>
        </div>
      </div>
    `

    renderWebComponent(html, this.shadowRoot, [commonStyles, submissionListsStyles]);
    setTimeout(() => {
        window.scrollTo(0, 0);
        this.resizeInfoCol()
    }, 100);
  }
}

window.customElements.define("submission-list-confirmation-component", SubmissionListConfirmationComponent);